import Figs from "./Figs";

export default Figs;